export default __webpack_public_path__ + "static/media/npc-watermark.2f0a1027.png";